import React, { useEffect } from 'react';

/**
 * /linaje en el SPA redirige a la landing F1 estática (canónica).
 * Fuente de verdad: repo LINAJE → entregables/landing-f1/
 * Deploy: frontend/public/linaje/ (+ .htaccess)
 * Stub React anterior (kit + modal Wompi) ya no se muestra a Angelita.
 */
const LinajeMockLanding = () => {
  useEffect(() => {
    window.location.replace('/linaje/');
  }, []);

  return (
    <main style={{ padding: '2rem', fontFamily: 'Georgia, serif', textAlign: 'center' }}>
      <p>Abriendo Linaje…</p>
      <p>
        <a href="/linaje/">javiland.com/linaje/</a>
      </p>
    </main>
  );
};

export default LinajeMockLanding;
